module.exports = __webpack_public_path__ + "assets/883936aad11b1655ff829d51c8baa5fd.png";